import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SHOW_MODAL_ON_ERROR } from '../../interceptors/interceptor.token';
import { LIB_CONFIG, LibConfig } from '../../lib.config';
import { checkParams } from '../../shared/utils/check-params.util';
import { SucheError } from './suche-error';

export enum BildungszielServiceParams {
  DKZ_IDS = 'ids',
  OBERKNOTEN_DKZ_IDS = 'dkzIds',
  UMKREIS = 'uk',
  SUCHWORT = 'suchwort',
  SYSTEMATIK = 'systematik',
  ORTSUNABHAENGIG = 'ortsunabhaengig'
}

@Injectable({
  providedIn: 'root'
})
export class BildungszielClient {
  private readonly libConfig = inject<LibConfig>(LIB_CONFIG);
  private readonly http = inject(HttpClient);

  public static SERVER_ERROR = 'NOW_WBSUCHE_BILDUNGSZIELE_SERVER_ERROR';

  public getBildungszielForSeteId(ids: HttpParams): Observable<Array<number>> {
    return this.http
      .get<Array<number>>(`${this.libConfig.backendHost}/pc/v1/bildungsziel/familie`, {
        params: checkParams(ids),
        responseType: 'json',
        context: new HttpContext().set(SHOW_MODAL_ON_ERROR, true)
      })
      .pipe(
        catchError((error) => {
          throw new SucheError('Fehler beim Laden des Bildungsziels', error);
        })
      );
  }

  public getBezeichnungById(id: number): Observable<string> {
    return this.http
      .get(`${this.libConfig.backendHost}/pc/v1/bildungsziel/bezeichnung?dkzId=${id}`, {
        responseType: 'text'
      })
      .pipe(
        catchError((error) => {
          throw new SucheError('Fehler beim Laden der Bezeichung des Bildungsziels', error);
        })
      );
  }
}
